import "./business-banner.css";

const BusinessBanner = () => (
  <div className="business-banner">
    <div className="business-banner__inner">
      <p className="business-banner__title">
        <span>프랜차이즈를 위한</span>
        <span>맞춤형 전용유 제조 및 배송</span>
      </p>
    </div>
  </div>
);

export default BusinessBanner;
